import EventBus from "@/helpers/event-bus";

const pointerHover = {
	methods: {
		onPointerMouseEnter(ev, type = "default") {
			const parent = ev.currentTarget;
			EventBus.$emit(EventBus.pointer.enter, { el: parent, type, parent });
		},
		onPointerMouseLeave(ev, type = "default") {
			const parent = ev.currentTarget;
			EventBus.$emit(EventBus.pointer.leave, { el: parent, type, parent });
		},
		addLinksListener() {
			this.$nextTick(() => {
				const aEl = this.$el.getElementsByTagName("a");
				aEl.forEach((element) => {
					if (!element.classList.contains("exlude_hover")) {
						element.addEventListener("mouseenter", (ev) => this.onPointerMouseEnter(ev, "link"));
						element.addEventListener("mouseleave", (ev) => this.onPointerMouseLeave(ev, "link"));
					}
				});
			});
		},
		removeLinksListener() {
			const aEl = this.$el.getElementsByTagName("a");
			aEl.forEach((element) => {
				element.removeEventListener("mouseenter", (ev) => this.onPointerMouseEnter(ev, "link"));
				element.removeEventListener("mouseleave", (ev) => this.onPointerMouseLeave(ev, "link"));
			});
		},
	},
};

export default pointerHover;
